import React from 'react';
import styled from 'styled-components';
import t from 'shared/utils/translation';

type Props = {
  className: string;
  showComponent: React.ReactElement<any>;
};

export default function ShowDetails(props: Props) {
  const [show, setShow] = React.useState(false);

  return (
    <div className={props.className}>
      {!show && (
        <Link type="a" onClick={() => setShow(true)}>
          {t('gdpr.shared.show_details')}
        </Link>
      )}
      {show && (
        <React.Fragment>
          <div>{props.showComponent}</div>
          <Link type="a" onClick={() => setShow(false)}>
            {t('gdpr.shared.hide_details')}
          </Link>
        </React.Fragment>
      )}
    </div>
  );
}

const Link = styled.a`
  padding-top: 5px;
  display: inline-block;
  cursor: pointer;
`;
